import { useCallback, useState } from 'react';

export interface ToggleFunctions {
    on: () => void;
    off: () => void;
    toggle: () => void;
}

export function useToggle(defaultToggle: boolean): [boolean, ToggleFunctions] {
    const [isOn, setToggle] = useState(defaultToggle);

    const toggle = useCallback(() => setToggle((status) => !status), [setToggle]);
    const on = useCallback(() => setToggle(true), [setToggle]);
    const off = useCallback(() => setToggle(false), [setToggle]);

    return [isOn, { on, off, toggle }];
}
